import { createApp } from 'vue'
import VueUeditorWrap from 'vue-ueditor-wrap'
import ElDialog from 'element-plus'
import ElIcons from '../../components/ElIcons'
// import 'element-plus/dist/index.css'
function makeDialog(option) {
  var dom = document.createElement('div');
  document.getElementsByTagName('body')[0].appendChild(dom);

  //动态创建template
  let tpl = '\
        <el-dialog \
            :width="dialogWidth"\
            :top="dialogTop"\
            :close-on-click-modal="true" \
            :custom-class="customClass" \
            :title="title" \
            v-model="show" \
            :before-close="handleClose" \
            @close="close">\
                <dialogContent  @close="closeDialog" @confirm="confirmDialog" :value="dialogData"></dialogContent>\
        </el-dialog>';

  //创建一个Vue实例
  const app = createApp({
    data () {
      return {
        //从调用文件获取(参数传入)
        title: option.title,
        show: true,
        dialogData: option.data,
        dialogWidth: '675px',
        dialogTop: '10vh'
      };
    },
    template: tpl,
    computed: {
      customClass(){
        return `el-dialog--width-${option.size || 'auto'}`;
      }
    },
    methods: {
      handleClose(done){
        if (option.beforeClose) {
          option.beforeClose(done);
        } else {
          done();
        }
      },
      close() {
        if (option.close) {
          option.close();
        }
        document.getElementsByTagName('body')[0].removeChild(dom);
        window.UE.delEditor('editor-demo-01')
      },

      closeDialog(){
        this.show = false
      },
      confirmDialog(result){
        this.show = false
        option.confirm && option.confirm(result)
      }
    },
    components: {
      dialogContent: option.component,//传入的内容模块
    },
    created() {
      if(option.data.width){
        this.dialogWidth = option.data.width;
      }
    }
  })
  app.component('ElIcons', ElIcons)
  app.use(VueUeditorWrap)
  app.use(ElDialog, { size: 'default', zIndex: 888 }).mount(dom);
  return app;
}

export default {
  open(options){
    return makeDialog(options)
  }
}
